import * as React from "react";
import { Block } from "kanopi-components/Block";
import { HeadingLarge, LabelMedium } from "kanopi-components/typography";
import { Placeholder } from "kanopi-components/Placeholder";
import { Rhetoricals } from "../Rhetorical";
import { SectionHeader } from "kw/components/SectionHeader/SectionHeader";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useUnderBreakpoint } from "kanopi-components/useUnderBreakpoint";

type TChatFlowProps = {
  title: string;
  description?: string;
  help?: string;
  loading?: boolean;
  children: React.ReactNode;
  rhetoricals?: TRhetorical[];
};

export function ChatFlow({
  title,
  description,
  help,
  loading = false,
  children,
  rhetoricals,
}: TChatFlowProps) {
  const [, theme] = useStyletron();
  const isMobile = useUnderBreakpoint("medium");
  const { scale900, scale800 } = theme.sizing;

  const hasRhetoricals = rhetoricals?.length && rhetoricals?.length > 0;

  return (
    <Placeholder loading={loading}>
      <SectionHeader title={title} />
      {!!description && (
        <HeadingLarge
          marginTop={["scale650", "scale650", "scale800"]}
          marginBottom={0}
          center
          overrides={{
            Block: {
              style: {
                fontSize: isMobile ? scale800 : scale900,
                textAlign: "center",
              },
            },
          }}
        >
          {description}
        </HeadingLarge>
      )}
      {!!help && (
        <Block marginTop="scale1000" maxWidth="70%">
          <LabelMedium color={theme.colors.contentTertiary} center>
            {help}
          </LabelMedium>
        </Block>
      )}
      {!!hasRhetoricals && (
        <Block marginTop="scale800">
          <Rhetoricals rhetoricals={rhetoricals} />
        </Block>
      )}
      <Block
        marginTop={hasRhetoricals ? "scale700" : "scale1400"}
        marginLeft="auto"
        marginRight="auto"
      >
        {children}
      </Block>
    </Placeholder>
  );
}
